import { TimeTrackingSessionKeys } from "@/features/timeTrackingPayroll/timeTrackingPayroll.constants";

// Time tracking constants
export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_DAY = 86400;
export const FIRST_BREAK_DELAY_HOURS = 4; // First break occurs 4 hours after start
export const SECOND_BREAK_DELAY_HOURS = 10.5; // Second break occurs 10.5 hours after start
export const FIRST_BREAK_DURATION_HOURS = 0.5; // First break is always 30 minutes
export const WEEKEND_DAYS = [0, 6]; // Sunday = 0, Saturday = 6

/**
 * Gets fortnight value from session storage
 * @returns {string} Fortnight string or empty string
 */
export const getFortnightFromSession = (): string => {
  return sessionStorage.getItem(TimeTrackingSessionKeys.FORTNIGHT) || "";
};
/**
 * Calculate total time for a specific breakdown title
 * @param {Array} breakDowns - Array of breakdown objects with title and time properties
 * @param {string} title - The title to filter by
 * @returns {number} - Total time for the specified title
 */
export const calculateBreakdownTotal = (
  breakDowns: { title: string; time: number }[] | undefined,
  title: string,
): number => {
  return (
    breakDowns
      ?.filter((b) => b.title === title)
      .reduce((acc, b) => acc + b.time, 0) || 0
  );
};
